module.exports = __webpack_public_path__ + "static/media/bride_groom.f13c13d6.svg";